import component from './massia.application.component';
import svcApplication from './massia.application.service';
import svcClient from './massia.client.service';

export { component, svcApplication, svcClient };
